import { ClientAuth, Device, Store } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { checkCanAutoPlay } from '@/utils';
import { useCallback, useEffect, useMemo, useRef } from 'react';

export const IntroPage = () => {
  const router = useRouter();
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasStarted = useRef(false);
  const didNavigate = useRef(false);
  const isWebOS = useMemo(() => Device.isWebOS, []);

  useEffect(() => {
    if (isWebOS) {
      if (ClientAuth.user) {
        router.push('/home', { replace: true });
      } else {
        router.push('/login', { replace: true });
      }
    }
  }, [isWebOS, router]);

  const navigateToSplash = useCallback(() => {
    if (didNavigate.current) return;
    didNavigate.current = true;
    checkCanAutoPlay();
    setTimeout(() => {
      router.push('/splash', { replace: true });
    }, 500);
  }, [router]);

  const handleCanPlay = useCallback(async () => {
    if (hasStarted.current || !videoRef.current) return;
    hasStarted.current = true;
    try {
      await videoRef.current.play();
    } catch {
      navigateToSplash();
    }
  }, [navigateToSplash]);

  const handleError = useCallback(
    (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
      console.error(e);
      navigateToSplash();
    },
    [navigateToSplash],
  );

  const mute = useMemo(() => sessionStorage.getItem('autoPlay') !== 'true', []);
  const src = useMemo(() => Store.get('resources').splashIntroVideo.landscape, []);

  if (isWebOS) return null;

  return (
    <div className="bg-black w-[1920px] h-[1080px]">
      <span className="font-babyshark absolute top-0 left-0 opacity-0">{'ㅤ'}</span>
      <span className="font-roboto absolute top-0 left-0 opacity-0">{'ㅤ'}</span>
      <video
        ref={videoRef}
        className="w-full h-full"
        src={src}
        onEnded={navigateToSplash}
        onError={handleError}
        onCanPlay={handleCanPlay}
        muted={mute}
        controls={false}
      />
    </div>
  );
};
